import { KeyboardArrowUp } from '@mui/icons-material';
import { Fade, IconButton, useScrollTrigger } from '@mui/material';

import theme from 'styles/theme/theme';

interface BackToTopButtonProps {
  threshold?: number;
}

export const BackToTopButton = ({ threshold = 400 }: BackToTopButtonProps) => {
  const backToTopTrigger = useScrollTrigger({ threshold, disableHysteresis: true });

  return (
    <Fade in={backToTopTrigger}>
      <IconButton
        style={{
          position: 'fixed',
          bottom: '2rem',
          right: '2rem',
          backgroundColor: theme('de').palette.primary.main,
          borderRadius: 25
        }}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <KeyboardArrowUp fontSize="large" style={{ color: 'white' }} />
      </IconButton>
    </Fade>
  );
};
